// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"11":"e36f7cdd","98":"ed58e262","125":"a2ec3e93","179":"cff90eef","234":"52ce7762","256":"cb4cd2ed","353":"385770e8","363":"6001267f","541":"06e3013d","546":"27898610","913":"0c0617dd","944":"93dc527b"}[chunkId] + ".js";
};